module.exports = __webpack_public_path__ + "fonts/deposit-guide-1.008f7f5ds.png";